import React, { useContext, useEffect } from 'react';
import Users from '../users/Users';
import UserForm from '../users/UserForm';
import UserFilter from '../users/UserFilter';
import AuthContext from '../../context/auth/authContext';

const UsersPage = () => {
  const authContext = useContext(AuthContext);

  const { user } = authContext;

  useEffect(() => {
    authContext.loadUser();
    //eslint-disable-next-line
  }, []);

  if (user && ['admin', 'user'].indexOf(user.role) !== -1) {
    return (
      <div className='grid-2'>
        <div>
          <UserForm />
        </div>
        <div>
          <UserFilter />
          <Users />
        </div>
      </div>
    );
  } else {
    return <div>{/* <h1>Not Authorized</h1> */}</div>;
  }
};

export default UsersPage;
